import InstrucoesNotaFiscal from 'src/components/instrucaoNotaFiscal'

function InstrucoesNF() {
  return <InstrucoesNotaFiscal />
}

export default InstrucoesNF
